import { RiderCoverageDto } from 'enrollment/queries/useBenefitCategoryQuery/types';
import { PlanRiderDto } from 'enrollment/queries/useBenefitPlansQuery/types';
import { RestrictionsDto } from 'enrollment/queries/useRestrictionsQuery/types';

export const getRiderCoverage = (
  rider: PlanRiderDto,
  riderCoverages?: RiderCoverageDto[],
  coverageLineId?: number
) => {
  if (coverageLineId) {
    return riderCoverages?.find(
      (cov) => cov.coverage_line_id === coverageLineId
    );
  }
  return riderCoverages?.find(
    (cov) => cov.org_benefit_id === rider.org_benefit_id
  );
};

export const isRiderLERestricted = (
  restrictions: RestrictionsDto | undefined,
  riderInfo: PlanRiderDto,
  hasCoverage = false
) => {
  const riderRestrictions = restrictions?.data?.find(
    (r) => r.org_benefit_id === riderInfo.org_benefit_id
  );

  if (!riderRestrictions) {
    return false;
  }

  return (
    !riderRestrictions.elect ||
    (!riderRestrictions.increase && !hasCoverage) || // they canNOT increase and there is no coverage
    (!riderRestrictions.decrease && hasCoverage) // they canNOT decrease and has a coverage
  );
};
